import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import DynamicArticle from "../pages/article/DynamicArticle";
import ShoppingGuide from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-litbuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "/article/:slug",
    element: <DynamicArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;